import gql from 'graphql-tag';

/**
 * Mutation to hide an inspection template from a building's inspectors.
 * Requires the template to already be owned by the requesting channel.
 */
export const hideInspectionTemplateMutation = gql`
  mutation HideInspectionTemplate($input: HideInspectionTemplateInput!) {
    hideInspectionTemplate(input: $input) {
      success
      newVersion
    }
  }
`;
